import React, {useEffect, useState} from 'react'
import { Form, FormControl, Tab, Tabs } from 'react-bootstrap'
import { createUser, saveWinner } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { DeleteForever } from '@mui/icons-material';
import statesData from './states.json'
import { FaPlus } from 'react-icons/fa';
const Giveaway = () => {
    const navigate = useNavigate()
    const [data, setData ] = useState({ });
    const [password, setPassword] = useState('');
    const [image, setImage] = useState();
    const [imageStatus, setImageStatus] = useState(false);
    const [states, setStates] = useState(statesData);
    const [lgas, setLgas] = useState();
    const [userDocs, setUserDocs] = useState([]);
    const [docTitle, setDocTitle] = useState(null);
    const [docFile, setDocFile] = useState(null);
    const handleChange = (e) => {
        setData({ ...data, [e.target.name] : e.target.value});
    }
    const units = [
        'Kitchen',
        'Front Office/Reception',
        'Restaurant',
        'Security',
        'Laundary',
        'House Keep',
        'Maintenance',
        'Saloon',
        'Cashier',
        'Store',
        'Gym',
        'Baking Unit',
        'Other'
    ]
    const handleSubmit = async (e) => {
      e.preventDefault()
    //   window.start_load();
      // console.log('form submitted.');
      let formId = document.getElementById('newUser');
      const formData = new FormData(formId);
      const process = async () => {
        console.log(formData);
        const response = await saveWinner(formData)
        console.log(response);
        if(response.success){
            // Swal.fire('Success', response.message, 'success');///
            Swal.fire({
                title: 'Successful',
                icon:"success",
                html:`<b>${response.message} <p>Ref: TPI${response.ref}</p></b> `,
                confirmButtonColor: 'blue',
                confirmButtonText: 'Close',
                // closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
            })
            e.target.reset();
        }else{
            // Swal.fire('Failed', response.message, 'error')
            Swal.fire({
                title: 'Failed',
                icon:"error",
                confirmButtonColor: 'red',
                confirmButtonText: 'Close',
                html:`<b class='text-danger'>${response.message}</b>`,
                // closeButtonHtml: `<button className="btn btn-color"> Close </button>`
            })
        }
      }
      
        process();
    //   window.stop_load();
    }

    useEffect(() => {
        // console.log(data);
        
        document.title = 'Give Away | Taste Place Investment'
    }, [])
    useEffect(() => {
        console.log(data);
    }, [data])
  return (
    <div className='giveaway m-1 px-2 py-5'
    style={{ 
        // backgroundColor: 'whitesmoke',
        height: '99vh'
     }}
    >
        {/* <div className=' d-flex justify-content-center mb-2' > */}
            <div className='text-center'>
                <img src='/tph_logo.png' width={'50px'} height={'50px'} alt='logo' />
            </div>
            <h3 className='text-center'><b className=" mb-5 header-body-title text-center"> Taste Place IT Officer's Baby Naming Give-Away </b></h3> 
        {/* <button className='btn btn-md bg'><b> Generate IDs </b></button> */}
        {/* </div> */}
        <form action="" id="newUser"
                        onSubmit={handleSubmit}
                        >
             <div className="card">
                    <div className="card-body">
                        
                        
                            <div className="row justify-content-center">
                            
                                <div className="col-md-6 border-right">
                                    <h4 className='text-center'><b className="text-muted text-center">Kindly Provide your Info!!!</b></h4>
                                   
                                   <div className="form-group">
                                        <label className="control-label text-muted">Staff ID. </label>
                                        <input placeholder="Enter Name or StaffID" required
                                        onChange={handleChange}
                                        type="text" className="form-control form-control-md" name="name" />
                                        
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label text-muted">Department/Unit </label>
                                        <select required
                                        onChange={handleChange}
                                        size='sm' name="unit" id="gender" className=" form-select form-control form-control-md">
                                            <option className="text-muted" value="">Select Department/Unit ... </option>
                                            {
                                                units.map((unit, i) => (

                                                    <option value={unit}>{unit}</option>
                                                ))
                                            }
                                        </select>
                                        
                                    </div>
                                    <div className="form-group">
                                        <div className='d-flex justify-content-between'>
                                            <div className='form-group'>
                                               <label className="control-label text-muted">Phone No. </label>
                                                <input required placeholder='enter phone number'
                                                onChange={handleChange}
                                                type="number" className="form-control form-control-md" name="phone" />
                                            </div>
                                            <div className='form-group'>
                                                <label className="control-label text-muted">Network</label>
                                                <Form.Select required name="network">
                                                    <option className="text-muted" value=''> Select... </option>
                                                    <option value="mtn"> MTN </option>
                                                    <option value="airtel"> AIRTEL </option>
                                                    <option value="glo"> GLO </option>
                                                </Form.Select>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <hr />
                            <div className="col-lg-12 text-right justify-content-center d-flex">
                                
                                <button
                                type='submit'
                                className="btn btn-color btn-lg ms-2"
                                style={{ width: '130px' }}
                                >Submit</button> 
                            </div>
                        {/* </form> */}
                    </div>
                </div>
        </form>
    </div>
  )
}

export default Giveaway